import * as React from "react";
import { styled } from "@mui/material";
import { ReactComponent as PlayStoreIcon } from "../assets/playstore_icon.svg";
import { ReactComponent as AppleStoreIcon } from "../assets/applestore_icon.svg";
import { useCallback } from "react";
import {
  ACTION,
  CATEGORY,
  evt,
  isCordovaApp,
  isInStandaloneMode,
} from "fe-common/analytics/analytics";
import { isMobile } from "../../utils/isMobile";

//region [[ Styles ]]

const DeviceStoreIconView = styled("div")({
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexFlow: "column",
  cursor: "pointer",
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface DeviceStoreIconProps {
  className?: string;
  analyticsLabel?: string;
  onClick?: () => void;
  appType?: AppType;
}

//endregion [[ Props ]]
export enum AppType {
  AGENT = "AGENT",
  PATIENT_1ST = "PATIENT_1ST",
}

//region [[ Functions ]]
//endregion [[ Functions ]]
export const PLAY_MARKET_URL =
  "https://play.google.com/store/apps/details?id=com.kahun.mobile";
export const APP_STORE_URL = "https://apps.apple.com/us/app/kahun/id1463318362";

export const PATIENT1_PLAY_MARKET_URL =
  "https://play.google.com/store/apps/details?id=com.kahun.patient";
export const PATIENT1_APP_STORE_URL =
  "https://apps.apple.com/us/app/patient-1st-by-kahun/id1575366787";

export const DeviceStoreIcon = ({
  analyticsLabel,
  onClick,
  ...props
}: DeviceStoreIconProps) => {
  const notifyInstall = useCallback(() => {
    evt({
      category: CATEGORY.INSTALL_APP_POPOVER,
      action: ACTION.USER_CLICKED_STORE_LINK_WINDOW,
      label: analyticsLabel || "",
    });
  }, [analyticsLabel]);

  const goToAppStore = useCallback(() => {
    notifyInstall();
    window.open(
      !props.appType || props.appType === AppType.AGENT
        ? APP_STORE_URL
        : PATIENT1_APP_STORE_URL,
      "_blank",
    );
    onClick && onClick();
  }, [notifyInstall, onClick]);

  const goToPlayMarket = useCallback(() => {
    notifyInstall();
    window.open(
      !props.appType || props.appType === AppType.AGENT
        ? PLAY_MARKET_URL
        : PATIENT1_PLAY_MARKET_URL,
      "_blank",
    );
    onClick && onClick();
  }, [notifyInstall, onClick]);

  // don't show the icon on apps
  if (isCordovaApp() || isInStandaloneMode()) return null;

  return (
    <DeviceStoreIconView className={"device-icon " + props.className}>
      {isMobile.iOS() && <AppleStoreIcon onClick={goToAppStore} />}
      {isMobile.Android() && <PlayStoreIcon onClick={goToPlayMarket} />}
      {/* In desktop show both icons */}
      {!isMobile.iOS() && !isMobile.Android() && (
        <>
          <AppleStoreIcon onClick={goToAppStore} />{" "}
          <PlayStoreIcon onClick={goToPlayMarket} />
        </>
      )}
    </DeviceStoreIconView>
  );
};
